import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ProtectedRoute from './components/components/route_protection/protectedRoute.jsx';
import Login from './components/login/login.jsx';
import Users2 from './tables/users/users2.jsx'; // Import komponentu Users2
import Sports from './tables/sports/sports.jsx'; // Import komponentu Users2
import NotFound from './tables/notFound.jsx'; // Import komponentu NotFound
import Opinions from './tables/opinions/opinions.jsx';
import Trainings from './tables/trainings/trainings.jsx';
import Notifications from './tables/notifications/notifications.jsx';
import Statistics from './tables/statistics/Statistics.jsx';
import Faq from './tables/faq/faq.jsx';
import Documents from './tables/documents/documents.jsx';
import Encyclopedia from './tables/encyclopedia/encyclopedia.jsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<ProtectedRoute Component={Users2} LoginComponent={Login} />}
        />
        <Route
          path="/sports"
          element={<ProtectedRoute Component={Sports} LoginComponent={Login} />}
        />
        <Route
          path="/statistics"
          element={<ProtectedRoute Component={Statistics} LoginComponent={Login} />}
        />
        <Route
          path="/trainings"
          element={<ProtectedRoute Component={Trainings} LoginComponent={Login} />}
        />
        <Route
          path="/notifications"
          element={<ProtectedRoute Component={Notifications} LoginComponent={Login} />}
        />
        <Route
          path="/documents"
          element={<ProtectedRoute Component={Documents} LoginComponent={Login} />}
        />
        <Route
          path="/encyclopedia"
          element={<ProtectedRoute Component={Encyclopedia} LoginComponent={Login} />}
        />
        <Route
          path="*"
          element={<ProtectedRoute Component={NotFound} LoginComponent={Login} />}
        />
        <Route
          path="/opinions"
          element={<ProtectedRoute Component={Opinions} LoginComponent={Login} />}
        />
        <Route
          path="/faq"
          element={<ProtectedRoute Component={Faq} LoginComponent={Login} />}
        />
      </Routes>
    </Router>
  );
}

export default App;